import { PickupLocator as v } from "./-pickup-locator.js";
import { a as w } from "./chunk-BaseElement-CJM6sCUz.js";
import { C as I, a as P } from "./chunk-gqlOperations-D4wOnjh5.js";
import { W as _ } from "./chunk-WithApiClient-Da1nY1F5.js";
import { W as k } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { h as m } from "./chunk-task-Cm4nHG2L.js";
import { t as S } from "./chunk-custom-element-CN0MC8o7.js";
import { n as d } from "./chunk-property---aaewZr.js";
var C = Object.defineProperty, E = Object.getOwnPropertyDescriptor, n = (e, t, o, i) => {
  for (var r = i > 1 ? void 0 : i ? E(t, o) : t, a = e.length - 1, s; a >= 0; a--)
    (s = e[a]) && (r = (i ? s(t, o, r) : s(r)) || r);
  return i && r && C(t, o, r), r;
};
const M = "_preferred_delivery_method", T = "_preferred_store";
let c = class extends k(
  _(w)
) {
  constructor() {
    super(), this.deliveryMethod = "", this.pickupHandle = "", this.locationTitle = "", this._getCartPreferences = new m(this, {
      task: async () => {
        var p, l, h, u, y, f;
        const o = `gid://shopify/Cart/${(await (await fetch("/cart.json")).json()).token}`;
        if (!o)
          throw new Error("No cart ID found");
        const i = {
          preferences: {
            delivery: {
              deliveryMethod: this.deliveryMethod
            }
          }
        }, r = await this.$api.client.storefront({
          body: {
            query: I,
            variables: {
              id: o,
              buyerIdentity: i
            }
          }
        });
        if (!r)
          throw new Error("No data returned from API");
        const a = (h = (l = (p = r.cart.buyerIdentity) == null ? void 0 : p.preferences) == null ? void 0 : l.delivery) == null ? void 0 : h.deliveryMethod[0];
        a && (this.deliveryMethod = a);
        const s = (f = (y = (u = r.cart.buyerIdentity) == null ? void 0 : u.preferences) == null ? void 0 : y.delivery) == null ? void 0 : f.pickupHandle[0];
        return s && (this.pickupHandle = s), r;
      },
      args: () => []
    }), this._cartUpdateTask = new m(this, {
      task: async ([e, t]) => {
        if (!e) return;
        const r = `gid://shopify/Cart/${(await (await this.createCartWithDeliveryMethod(e)).json()).token}`, a = {
          preferences: {
            delivery: {
              deliveryMethod: e,
              pickupHandle: t
            }
          }
        }, s = await this.$api.client.storefront({
          body: {
            query: P,
            variables: {
              id: r,
              buyerIdentity: a
            }
          }
        });
        if (!s)
          throw new Error("No data returned from API");
        return s;
      },
      args: () => [this.deliveryMethod, this.pickupHandle]
    }), this.onCartItemsAdded = async (e) => {
      var r;
      if (e.detail.target.tagName.toLowerCase() != "product-form" || (this.selectedField = this.querySelector(`${this.inputSelector}:checked`), !((r = this.selectedField) != null && r.value))) return;
      const i = this.selectedField.getAttribute("data-pickup-id");
      this.deliveryMethod = this.selectedField.value, this.pickupHandle = i || null, this.locationTitle = this.getAttribute("data-location-title") || "", this.updateLineItemPropertyInput(), await this._cartUpdateTask.run();
    }, this.inputSelector = 'input[name="pickup_availability"]', this.selectedField = this.querySelector(`${this.inputSelector}:checked`);
  }
  async createCartWithDeliveryMethod(e) {
    const t = {
      [M]: e
    };
    return this.locationTitle && (t[T] = this.locationTitle), await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes: t })
    });
  }
  async selectPreferredMethod() {
    if (await this._getCartPreferences.run(), this.deliveryMethod) {
      const t = this.querySelector(
        `${this.inputSelector}[value="${this.deliveryMethod}"]`
      );
      t && (t.checked = !0);
    } else {
      const t = this.querySelector(
        `${this.inputSelector}[value="SHIPPING"]`
      );
      t && (t.checked = !0);
    }
    const e = this.querySelector(
      "pickup-locator"
    );
    e && (customElements.define("pickup-locator", v), await e.init(
      this.pickupHandle ? this.pickupHandle : ""
    ));
  }
  updateLineItemPropertyInput() {
    const e = document.querySelector(
      "[data-pickup-item-property]"
    );
    e && (e.disabled = this.deliveryMethod == "SHIPPING");
  }
  connectedCallback() {
    this.selectPreferredMethod(), window.addEventListener("cart:items-added", this.onCartItemsAdded);
  }
};
n([
  d()
], c.prototype, "deliveryMethod", 2);
n([
  d()
], c.prototype, "pickupHandle", 2);
n([
  d()
], c.prototype, "locationTitle", 2);
c = n([
  S("cart-delivery-method")
], c);
export {
  c as CartDeliveryMethod
};
